import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { useDispatch } from 'react-redux'
import { getUserData } from "./redux/action/action";
//importing components
import HomeRouts from './homeRouts'
import Dashboard from "./Dashboard/dashboardRoutes";
import { GetUserAddress } from "./redux/action/user";
import { useSelector } from 'react-redux';
const MainApp = ({ ConnectToWallet, useraccount, contract }) => {
  const Aut = useSelector(state => state.AutReducer)
  const dispatch = useDispatch()
  // console.log(Aut.loinAddress.find, "this is Aut====>")
  React.useEffect(() => {
    if (useraccount !== undefined && contract !== undefined) {
      dispatch(getUserData(useraccount, contract))
    }
  }, [useraccount, contract])

  React.useEffect(() => {
    if (useraccount !== undefined && contract !== undefined) {
      dispatch(GetUserAddress(useraccount))
    }
  }, [useraccount, contract])



  // const AuthRoute = ({ component: Component, aut, ...rest }) => (
  //   <Route
  //     {...rest}
  //     path="/dashboard"
  //     exact
  //     render={(props) =>
  //       !aut ? (
  //         <Redirect
  //           to={{
  //             pathname: "/login",
  //             state: { from: props.location },
  //           }}
  //         />
  //       ) : (
  //         //  || isDemo
  //         <Component {...props} />
  //       )
  //     }
  //   />
  // );


  return (
    <>
      <Switch>
        <Route path="/dashboard" aut={Aut.loinAddress && Aut.loinAddress.find} >
          {/* <Route path="/dashboard" component={() => <Dashboard useraccount={useraccount} contract={contract} />}> */}
          <Dashboard useraccount={useraccount} contract={contract} />
        </Route>
        <Route path="/">
          <HomeRouts ConnectToWallet={ConnectToWallet} useraccount={useraccount} contract={contract} />
        </Route>

      </Switch>
    </>
  );
};

export default MainApp;


